import { useContext } from "react";
import { UploadContext, type UploadContextValue } from "@/shared/contexts/UploadContext";

export function useUpload(): UploadContextValue {
    const context = useContext(UploadContext);
    if (!context) {
        throw new Error("useUpload must be used within an UploadProvider");
    }
    return context;
}

export function useUploadOptional(): UploadContextValue | null {
    return useContext(UploadContext);
}
